import React, { useEffect, useState } from "react";
import Header from "../../layouts/Header.jsx";
import Sidebar from "../../layouts/Sidebar.jsx";
import { Table } from "antd";
import * as XLSX from "xlsx";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import alertify from "alertifyjs";
import "../../../node_modules/alertifyjs/build/css/alertify.css";
import "../../../node_modules/alertifyjs/build/css/themes/semantic.css";
// import AttendanceView from "./AttendanceView.jsx";
import ApiService from "../../service/httpService.js";

const AttendanceDownload = () => {
  //state management
  alertify.set("notifier", "position", "top-right");
  const [isLoding, setisLoding] = useState(false);
  const [datasource, setDataSource] = useState([]);
  const [menu, setMenu] = useState(false);
  // const [EditData, setEditData] = useState({})
  const [formData, setFormData] = useState({
    name: "All",
    fromDate: "",
    ToDate: "",
  });
  const [validation, setValidation] = useState({
    name: true,
    fromDate: true,
    ToDate: true,
  });
  const [isExport, setisExport] = useState(false);
  const [Employee, setEmployee] = useState([]);

  //date formating
  function formatSimpleDate(dateStr) {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  //time colculation
  function addTimes(time1, time2) {
    console.log("times", time1, time2);

    const [h1, m1, s1] = time1.split(":").map(Number);
    const [h2, m2, s2] = time2.split(":").map(Number);

    let totalSeconds = s1 + s2;
    let totalMinutes = m1 + m2 + Math.floor(totalSeconds / 60);
    let totalHours = h1 + h2 + Math.floor(totalMinutes / 60);

    totalSeconds = totalSeconds % 60;
    totalMinutes = totalMinutes % 60;

    return `${String(totalHours).padStart(2, "0")}:${String(
      totalMinutes
    ).padStart(2, "0")}:${String(totalSeconds).padStart(2, "0")}`;
  }

  function calculateDailyWorkingHours(data) {
    const newData = [];

    // Loop through each entry
    data.forEach((entry) => {
      const { employee_id, date, total_workedTime, inTime } = entry;

      // Find if the same employee and same date already exists
      const existingIndex = newData.findIndex(
        (item) => item.employee_id === employee_id && item.date === date
      );

      if (existingIndex >= 0) {
        // If found, update the existing entry by adding the worked time
        newData[existingIndex].total_workedTime = addTimes(
          total_workedTime ? total_workedTime : "00:00:00",
          newData[existingIndex].total_workedTime
            ? newData[existingIndex].total_workedTime
            : "00:00:00"
        );
        newData[existingIndex].inTime = inTime;
      } else {
        // If not found, push the current entry as a new one
        newData.push({ ...entry });
      }
    });

    console.log(newData);

    return newData;
  }

  //IsInchare
  const Is_Incharge = (Emp_id) => {
    const emp = Employee.find((item) => item.id === Emp_id);
    console.log("employee type", emp);
    if (emp.user_type == "incharge") {
      return true;
    }
  };

  //filter by name
  const namefilter = (Attendance) => {
    const data = Attendance.filter(
      (item) => formData.name === "All" || item.employee_id == formData.name
    );

    console.log("data", data);

    const updatedData = data.map((item) => {
      let status;
      if (Is_Incharge(item.employee_id)) {
        status = "Full Day";
      } else if (getSeconds(item.total_workedTime) >= 8 * 3600) {
        status = "Full Day";
      } else if (getSeconds(item.total_workedTime) >= 4 * 3600) {
        status = "Half Day";
      } else {
        status = "Absent";
      }

      return {
        ...item,
        att_status: status,
      };
    });

    console.log("Filtered and updated attendance data:", updatedData);
    return updatedData;
  };

  //employee names
  const employee_name = async () => {
    const res = await ApiService.getPublic(
      `get_data.php?table=employee&asign_field=id&asign_value=DESC&authToken=`
    );
    console.log(res);

    const names = res.filter((item) => item.user_type !== "admin");
    console.log(names);
    setEmployee(names);
  };

  useEffect(() => {
    employee_name();
  }, []);

  const exportAttendanceToExcel = (rawData) => {
    const FromDate = new Date(formData.fromDate);
    const ToDate = new Date(formData.ToDate);

    const dateList = [];
    for (let d = new Date(FromDate); d <= ToDate; d.setDate(d.getDate() + 1)) {
      const formatted = d.toISOString().slice(0, 10);
      dateList.push(formatted);
    }

    const employeeMap = new Map();

    rawData.forEach((item) => {
      const key = item.employee + "_" + item.mobile;
      if (!employeeMap.has(key)) {
        const row = {
          Name: item.employee,
          Mobile: item.mobile,
        };
        dateList.forEach((date) => {
          row[date] = ""; // init all with empty
        });

        employeeMap.set(key, row);
      }

      const workedSeconds = getSeconds(item.total_workedTime);
      let status = "";
      if (Is_Incharge(item.employee_id)) {
        status = "Full Day";
      } else if (workedSeconds >= 8 * 3600) {
        status = "Full Day";
      } else if (workedSeconds >= 4 * 3600 && workedSeconds < 8 * 3600) {
        status = "Half Day";
      } else {
        status = "-";
      }

      if (employeeMap.get(key)[item.date] !== undefined) {
        employeeMap.get(key)[item.date] = status;
      }
    });

    // 🔥 Set all empty date cells to "Absent"
    for (let row of employeeMap.values()) {
      dateList.forEach((date) => {
        if (!row[date]) {
          row[date] = "-";
        }
      });
    }

    const finalData = Array.from(employeeMap.values());

    const worksheet = XLSX.utils.json_to_sheet(finalData, {
      header: ["Name", "Mobile", ...dateList],
    });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance");

    const fileName = `Attendance_${formatDate(FromDate)}_to_${formatDate(
      ToDate
    )}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };

  const getSeconds = (timeStr) => {
    if (!timeStr) return 0;
    console.log("Timer str", timeStr);
    const [h, m, s] = timeStr.split(":").map(Number);
    return h * 3600 + m * 60 + s;
  };

  const formatDate = (dateObj) => {
    return dateObj.toISOString().slice(0, 10);
  };

  //fetching employee datas
  const fetchAttendance = async () => {
    setisLoding(true);
    try {
      const res = await ApiService.getPublic(
        `mp_attendance_report.php?from_date=${formData.fromDate}&to_date=${formData.ToDate}&authToken=`
      );
      console.log("employee", res);
      const Attendance = calculateDailyWorkingHours(res);
      const att = namefilter(Attendance);
      setDataSource(att);
      setisLoding(false);
      if (res === null || res.length === 0) {
        alertify.error("No Data Found");
      }
    } catch (err) {
      console.log("error on fetchAttendance", err);
      setisLoding(false);
    }
  };

  //export button
  useEffect(() => {
    if (datasource.length !== 0) {
      setisExport(true);
    } else {
      setisExport(false);
    }
  }, [datasource]);

  useEffect(() => {
    for (const key in formData) {
      const value = formData[key];
      if (
        value !== undefined &&
        value !== null &&
        value.toString().trim() !== ""
      ) {
        setValidation((prev) => ({ ...prev, [key]: true }));
      }
    }
  }, [formData]);

  const HandleGenerate = () => {
    let Isvalid = true;
    for (const key in formData) {
      const value = formData[key];
      if (
        value === undefined ||
        value === null ||
        value.toString().trim() === ""
      ) {
        Isvalid = false;
        setValidation((prev) => ({ ...prev, [key]: false }));
      }
    }

    if (Isvalid) {
      fetchAttendance();
    } else {
      alertify.error("Please select both From and To dates!");
    }
  };

  // const handleEditClick = (record) => {
  //   setEditData(record)
  //   console.log("record ", record)
  // }

  // const HandleExport = (data) => {

  //   // Step 1: Convert JSON data to worksheet
  //   const worksheet = XLSX.utils.json_to_sheet(data);

  //   // Step 2: Create a workbook and append the worksheet
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  //   const now = new Date();
  //   const formattedDate = now
  //     .toISOString()
  //     .replace(/[:.-]/g, "") // Remove unsafe characters
  //     .slice(0, 15); // Trim to avoid extra long filenames

  //   // Step 3: Write the workbook and trigger download
  //   XLSX.writeFile(workbook, `data${formattedDate}.xlsx`);

  // }

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  //   const timeToSeconds = (timeString) => {
  //       console.log("time string",timeString);
  //       const [hours, minutes, seconds] = timeString.split(":").map(Number);
  //       console.log("time string to second",hours * 3600 + minutes * 60 + seconds);
  //       return hours * 3600 + minutes * 60 + seconds;
  // }

  const columns = [
    {
      title: "Name",
      dataIndex: "employee",
      sorter: (a, b) => a.employee.localeCompare(b.employee),
    },
    {
      title: "Date",
      dataIndex: "date",
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
      render: (text) => formatSimpleDate(text),
    },
    {
      title: "InTime",
      dataIndex: "inTime",
      sorter: (a, b) => {
        const toMinutes = (t) =>
          parseInt(t.split(":")[0]) * 60 + parseInt(t.split(":")[1]);
        return toMinutes(a.inTime) - toMinutes(b.inTime);
      },
    },
    {
      title: "Check In Distance",
      dataIndex: "check_in_distance",
      sorter: (a, b) => a.check_in_distance - b.check_in_distance,
    },
    {
      title: "OutTime",
      dataIndex: "outTime",
      sorter: (a, b) => {
        const toMinutes = (t) =>
          parseInt(t.split(":")[0]) * 60 + parseInt(t.split(":")[1]);
        return toMinutes(a.outTime) - toMinutes(b.outTime);
      },
    },
    {
      title: "Check Out Distance",
      dataIndex: "check_out_distance",
      sorter: (a, b) => a.check_out_distance - b.check_out_distance,
    },
    {
      title: "Total Working Time",
      dataIndex: "total_workedTime",
      sorter: (a, b) => {
        const toMinutes = (t) =>
          parseInt(t.split(":")[0]) * 60 + parseInt(t.split(":")[1]);
        return toMinutes(a.total_workedTime) - toMinutes(b.total_workedTime);
      },
    },
    {
      title: "Attendance",
      dataIndex: "att_status",
      render: (text) => {
        const statusMap = {
          "Full Day": { label: "Full day", className: "bg-success" },
          "Half Day": { label: "Half day", className: "bg-warning" },
          Absent: { label: "Absent", className: "bg-danger" }, // Corrected: was 'bg-DANGER'
        };

        const status = statusMap[text];

        return status ? (
          <span className={`badge ${status.className}`}>
            <i className="fe fe-check me-1"></i> {status.label}
          </span>
        ) : null;
      },

      sorter: (a, b) => {
        const toMinutes = (t) =>
          parseInt(t.split(":")[0]) * 60 + parseInt(t.split(":")[1]);
        return toMinutes(a.total_workedTime) - toMinutes(b.total_workedTime);
      },
    },
    // {
    //   title: "Action",
    //   dataIndex: "Action",
    //   render: (text, record) => (
    //     <div className="table-invoice d-flex align-items-center">
    //       <div className="dropdown dropdown-action">
    //         <a
    //           className="btn-action-icon"
    //           data-bs-toggle="dropdown"
    //           aria-expanded="false"
    //           onClick={(e) => e.preventDefault()}
    //         >
    //           <i className="fas fa-ellipsis-v" />
    //         </a>
    //         <div className="dropdown-menu dropdown-menu-end">
    //           <ul>
    //             <li>
    //               <a
    //                 className="dropdown-item"

    //                 data-bs-toggle="modal"
    //                 data-bs-target="#AttendanceDownload-view"
    //                 onClick={() => { handleEditClick(record) }}
    //               >
    //                 <i className="fe fe-edit me-2" /> view
    //               </a>
    //             </li>
    //           </ul>
    //         </div>
    //       </div>
    //     </div>
    //   ),
    // }
  ];

  return (
    <div>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="content-page-header flex-column gap-3 ">
                <h5>Attendance Master</h5>
                <div className="page-content">
                  <div className="list-btn">
                    <ul className="filter-list d-flex align-items-center justify-content-center flex-column flex-xl-row gap-md-3">
                      <div className="d-flex flex-column flex-md-row gap-md-0">
                        <li>
                          {/* Search */}
                          <form className="m-0 d-flex align-items-center select">
                            <label className="form-label m-0">Name</label>
                            <select
                              className={`form-control ms-2 ${
                                validation.name ? "" : "input-error"
                              }`}
                              value={formData.name}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  name: e.target.value,
                                })
                              }
                            >
                              <option value="All">All</option>
                              {/* <option disabled style={{ fontSize: "8px", color: "#aaa" }}>────────────</option> */}
                              <option
                                disabled
                                style={{ fontSize: "12px", color: "#7638ff" }}
                              >
                                Employee Names
                              </option>
                              {Employee &&
                                Employee.map((item) => (
                                  <option value={item.id} key={item.id}>
                                    {item.name} - {item.mobile}
                                  </option>
                                ))}
                            </select>
                          </form>
                        </li>
                        <li>
                          {/* Search */}
                          <form className="m-0 d-flex align-items-center">
                            <label className="form-label m-0">From</label>
                            <input
                              type="date"
                              className={`form-control ms-2 ${
                                validation.fromDate ? "" : "input-error"
                              }`}
                              value={formData.fromDate}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  fromDate: e.target.value,
                                })
                              }
                            />
                          </form>
                        </li>
                        <li>
                          {/* Search */}
                          <form className="m-0 d-flex align-items-center">
                            <label className="form-label ms-2 mb-0">To</label>
                            <input
                              type="date"
                              className={`form-control ms-2  ${
                                validation.ToDate ? "" : "input-error"
                              }`}
                              value={formData.ToDate}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  ToDate: e.target.value,
                                })
                              }
                            />
                          </form>
                        </li>
                      </div>

                      <div className="d-flex gap-2">
                        <li>
                          <a
                            className="btn btn-primary"
                            onClick={HandleGenerate}
                          >
                            <i className="fa fa-cogs me-2" aria-hidden="true" />
                            Generate
                          </a>
                        </li>

                        {isExport && (
                          <li>
                            <a
                              className="d-flex align-items-center download-item btn btn-filters"
                              download=""
                              onClick={(e) => {
                                e.preventDefault();
                                exportAttendanceToExcel(datasource);
                              }}
                            >
                              <i className="far fa-file-text me-2" />
                              Export
                            </a>
                          </li>
                        )}
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* /Page line */}
            <div className="super-admin-list-head"></div>

            <div className="row">
              <div className="col-sm-12">
                <div className="card-table ">
                  <div className="card-body ">
                    <div className="table-responsive">
                      {isLoding ? (
                        <div className="d-flex justify-content-center">
                          <div className="spinner-border" role="status" />
                        </div>
                      ) : (
                        <Table
                          pagination={{
                            total: datasource && datasource.length,
                            showSizeChanger: true,
                            // onShowSizeChange: onShowSizeChange,
                            // itemRender: itemRender,
                          }}
                          columns={columns}
                          dataSource={datasource}
                          rowKey="id"
                        />
                      )}{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <AttendanceView Emp_data={EditData} fetchAttendance={fetchAttendance} /> */}
    </div>
  );
};

export default AttendanceDownload;
